import { ApplicationRef, ChangeDetectorRef, Component, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MatDialogState } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessageService, ErrorData } from 'src/app/services/message/message.service';
import { menuOptions } from 'src/data/menu-options.data';
import { HomeComponent } from '../../home/home.component';
import { ImportServiceV2 } from 'src/app/services/imports/import.service-v2';
import { CommonService } from 'src/app/services/common/common.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { ImportServiceV3 } from 'src/app/services/imports/import.service-v3';
import { ColumnMapping } from './step-processing/step-processing.component';
import { ImportacaoLinha } from 'src/models/interfaces/importação/upload-importacao-interface';
import { Status, StatusProcessamento } from 'src/models/interfaces/importação/status.enum';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { DetalhamentoImportacao } from 'src/models/interfaces/importação/detalhamento-importacao-interface';
import { BasicDialogComponent } from 'src/app/shared/componentes/basic-dialog/basic-dialog.component';
import { showError } from 'src/utils/showErrorMessage';
import { ImportServiceV3LoadingKeys } from 'src/models/keys/imports/imports.keys';
import { scheduleAppRefresh } from 'src/app/shared/utils/refresh-view';

enum StepsImport {
  stepUpload,
  stepProcessing,
  stepResult
}

@Component({
  selector: 'spe-importar-csv-personalizado',
  templateUrl: './importar-csv-personalizado.component.html',
  styleUrls: ['./importar-csv-personalizado.component.scss'],
  standalone: false
})
// os tres arquivos de importação são bem repetitivos, talvez valha a pena criar um componente para isso
export class ImportarCsvPersonalizadoComponent implements OnInit {
  private dialogReference?: MatDialogRef<BasicDialogComponent, any>;
  private showErrorMessage = showError;
  public message: string = '';
  public apiStatus: string | null = null;
  public alertMessage: string = '';
  public alertError: string = '';
  public alertTitle: string = '';
  public alertStatus: string | null = null;

  // Fail
  columnMappings: ColumnMapping[] = [];
  resolvedColumnCount: number = 0;
  requiredConfirmedCount: number = 0;
  public columnsNotIdentified: string[] = [];
  public columnsNotInFile: string[] = [];
  public requiredColumns: string[] = [];

  // Stepper
  // TODO
  public currentStep: StepsImport = StepsImport.stepUpload;
  public checkedStepUpload: boolean = false;
  public checkedStepProcessing: boolean = false;
  protected readonly StepsImport = StepsImport;

  // Processing sub-states
  public showStepFail: boolean = false;
  public showProcessing: boolean = false;
  public isChecking: boolean = true;
  public checked: boolean = false;
  public showStepError: boolean = false;
  public showStepAlert: boolean = false;
  public showStepCounters: boolean = false;

  public employees: number = 0;
  public benefits: number = 0;
  public errors: number = 0;
  public enableLoop: boolean = true;
  public firstLoading: boolean = true;

  // TODO
  public idImportacao?: number = 0;
  public statusImport: StatusProcessamento | null = null;
  private subscriptions: Subscription[] = [];
  private idClientGroup = localStorage.getItem('idGrupoCliente');
  public errorsToShow: ImportacaoLinha[] = [];
  public quantidadeLinhasComErro: number = 0;
  public editedLines: { idLinha: number; mapLinha: Record<string, string> }[] = [];
  public sigla = localStorage.getItem('sigla');
  public detalhamento: DetalhamentoImportacao | null = null;

  @ViewChild('createDialogTemplate') createDialogTemplate: TemplateRef<any> | undefined;

  constructor(
    public dialog: MatDialog,
    public readonly routerService: Router,
    private messageService: MessageService,
    private homeComponent: HomeComponent,
    public readonly importService: ImportServiceV2,
    public readonly importServiceV3: ImportServiceV3,
    public readonly commonService: CommonService,
    public readonly loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private ngZone: NgZone
  ) {
    let extrasState = this.routerService.getCurrentNavigation()?.extras.state;
    if (extrasState != null) {
      let success = extrasState['success'];
      if (success != null && success === true) {
        this.changeStep(StepsImport.stepResult);
      }
    }
  }

  public navigateToDetalhamento(): void {
    const url = this.routerService.serializeUrl(
      this.routerService.createUrlTree(['resumo-itens-importados'], {
        queryParams: { isNewUpload: true, idImportacao: this.idImportacao }
      })
    );
    window.open(url, '_blank');
  }

  public importResume = () => {
    const url = this.routerService.serializeUrl(this.routerService.createUrlTree([`resumo-itens-importados`]));
    window.open(url, '_blank');
  };

  public filesDataForm = new FormGroup({
    importFile: new FormControl<File | null>(null)
  });

  get filesDataFormControl() {
    return this.filesDataForm.controls;
  }

  ngOnInit(): void {
    this.homeComponent.setNewVariables('Importação de Arquivo CSV Personalizado', '', 'importacao/importar-arquivo');
    this.homeComponent.idleMenuContent = menuOptions[3].content;
    this.homeComponent.iconPath = 'assets/images/64_icon_earth_upload.png';
    this.pollImportStatus(true);
  }

  ngOnDestroy(): void {
    this.enableLoop = false;
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onChangeFile(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.filesDataForm.patchValue({
        importFile: file
      });
      document.getElementById('customFileLabel')!.innerHTML = file.name;
    }
  }

  public readonly openImportDialog = () => {
    let file = this.filesDataFormControl.importFile.value;
    let fileName: string = '';

    if (file != null) {
      fileName = file.name;
    }
    fileName = fileName.toLowerCase();
    if (file == null) {
      this.dialogReference = this.dialog.open(BasicDialogComponent, {
        width: '332px',
        data: {
          title: 'Arquivo não escolhido',
          message: 'Informe o arquivo que será importado.',
          action1: 'OK',
          icon: 'error'
        }
      });
    } else if (fileName.length > 3 && fileName.slice(-3) != 'csv') {
      this.dialogReference = this.dialog.open(BasicDialogComponent, {
        width: '332px',
        data: {
          title: 'Arquivo não aceito',
          message: 'Apenas arquivos com a extensão .csv são permitidos no upload.',
          action1: 'OK',
          icon: 'error'
        }
      });
    } else {
      localStorage.setItem('fileName', file!.name);

      this.isChecking = true;
      this.checked = false;
      this.showProcessing = true;
      this.showStepAlert = false;
      this.showStepError = false;
      this.showStepFail = false;
      this.changeStep(StepsImport.stepProcessing);

      const subscription = this.importServiceV3
        .upload(this.filesDataFormControl.importFile.value!, ImportServiceV3LoadingKeys.Default)
        .subscribe({
          next: (data) => {
            this.isChecking = false;
            this.idImportacao = data.idImportacao;
            this.columnsNotIdentified = data.cabecalhosDoArquivoNaoIdentificados;
            this.columnsNotInFile = data.cabecalhosParaCorrecao;
            this.requiredColumns = data.cabecalhoNaoIdentificado;
            this.pollImportStatus();
          },
          error: (err) => {
            this.changeStep(StepsImport.stepProcessing);
            this.showStepError = false;
            this.showStepAlert = true;
            this.showProcessing = false;
            this.alertTitle = 'Erro ao importar arquivo';

            this.alertMessage = `Tente novamente ou contate a`;
            this.alertError = err.error?.mensagem || err.message;

            setTimeout(() => {
              const message = this.commonService.getErrorMessage(err);
              if (message !== '') {
                this.showErrorMessage(this.dialog, message);
              }
            }, 100);
          }
        });

      this.subscriptions.push(subscription);
    }
  };

  private readonly pollImportStatus = (isFirst = false) => {
    if (isFirst) {
      this.isChecking = false;
      this.checked = true;
    }

    const subscription = this.importServiceV3
      .getUltimaImportacao(!isFirst ? ImportServiceV3LoadingKeys.Default : null)
      .subscribe({
        next: (response) => {
          const oldStatus = this.statusImport;
          const status = response.retorno.statusProcessamento;
          if (!this.idImportacao) {
            this.idImportacao = response.retorno.id;
          }

          if (status === StatusProcessamento.PROCESSANDO) {
            this.showProcessing = true;

            this.changeStep(StepsImport.stepProcessing);
            setTimeout(() => {
              if (this.enableLoop) {
                this.pollImportStatus();
              }
            }, 20000);
            return;
          }

          if (status === StatusProcessamento.CONCLUIDO_COM_FALHAS) {
            if (!isFirst) {
              this.changeStep(StepsImport.stepProcessing);
              this.showStepError = false;
              this.showStepAlert = true;
              this.showProcessing = false;
              this.alertTitle = 'Erro ao importar arquivo';

              this.alertMessage = '';
              this.alertError = response.retorno?.erroProcessamento || 'Ocorreu um erro ao importar o arquivo.';

              setTimeout(() => {
                const message = this.commonService.getErrorMessage(
                  `Erro: ${response.retorno?.erroProcessamento || 'Ocorreu um erro ao importar o arquivo.'}`
                );
                if (message !== '') {
                  this.showErrorMessage(this.dialog, message);
                }
              }, 100);
            }

            if (isFirst) {
              this.novaImportacao();
            }

            return;
          }

          if (status === StatusProcessamento.CORRIGIR_CABECALHO) {
            if (isFirst) {
              this.showProcessing = false;

              this.showResumeDialog('Corrigir Cabeçalho', response.retorno.nomeArquivo);
              return;
            }
            this.statusImport = StatusProcessamento.CORRIGIR_CABECALHO;
            this.resolvedColumnCount = 0;
            this.columnMappings = [];

            if (!this.columnsNotIdentified.length || !this.columnsNotInFile.length) {
              this.importServiceV3.validarCabecalho(this.idImportacao!.toString()).subscribe({
                next: (res) => {
                  this.columnsNotIdentified = res.cabecalhosDoArquivoNaoIdentificados;
                  this.columnsNotInFile = res.cabecalhosParaCorrecao;
                  this.requiredColumns = res.cabecalhoNaoIdentificado;

                  this.showProcessing = false;
                  this.changeStep(StepsImport.stepProcessing);
                },
                error: (err) => {
                  this.changeStep(StepsImport.stepProcessing);
                  this.showStepError = false;
                  this.showStepAlert = true;
                  this.showProcessing = false;

                  this.alertTitle = 'Erro ao validar cabeçalho';
                  this.alertMessage = `Tente novamente ou contate a`;
                  this.alertError = err.error?.mensagem || err.message;
                  this.refreshView();
                  setTimeout(() => {
                    const message = this.commonService.getErrorMessage(err);
                    if (message !== '') {
                      this.showErrorMessage(this.dialog, message);
                    }
                  }, 100);
                }
              });
            } else {
              this.showProcessing = false;
              this.changeStep(StepsImport.stepProcessing);
            }
            return;
          }

          if (status === StatusProcessamento.CORRIGIR_DADOS) {
            if (isFirst) {
              this.showProcessing = false;
              this.showResumeDialog('Corrigir Linhas', response.retorno.nomeArquivo);
              return;
            }

            this.statusImport = StatusProcessamento.CORRIGIR_DADOS;
            if (oldStatus === StatusProcessamento.CORRIGIR_CABECALHO || this.showStepError) {
              this.showStepError = true;
            }
            this.showProcessing = false;
            this.changeStep(StepsImport.stepProcessing);

            return;
          }

          if (status === StatusProcessamento.CONCLUIDO) {
            if (!isFirst) {
              this.importServiceV3
                .getDetalhamento(this.idImportacao!.toString(), ImportServiceV3LoadingKeys.Default)
                .subscribe({
                  next: (res) => {
                    this.detalhamento = res.detalhamento;

                    this.changeStep(StepsImport.stepResult);
                  },
                  error: (err) => {
                    this.changeStep(StepsImport.stepProcessing);
                    this.showStepError = false;
                    this.showStepAlert = true;
                    this.showProcessing = false;
                    this.alertTitle = 'Erro ao detalhar importação';
                    this.alertMessage = `Tente novamente ou contate a`;
                    this.alertError = err.error?.mensagem || err.message;
                    setTimeout(() => {
                      const message = this.commonService.getErrorMessage(err);
                      if (message !== '') {
                        this.showErrorMessage(this.dialog, message);
                      }
                    }, 100);
                  }
                });
            }
            if (isFirst) {
              this.novaImportacao();
            }
            setTimeout(() => {
              this.showProcessing = false;
            }, 300);
            return;
          }

          if (status === StatusProcessamento.CANCELADA) {
            this.novaImportacao();
            return;
          }
          this.showProcessing = false;
          if (isFirst) {
            this.setFirstLoading(false);
          }
        },
        error: (e) => {
          this.novaImportacao();
        }
      });
    this.subscriptions.push(subscription);
  };

  private setFirstLoading(value: boolean): void {
    this.firstLoading = value;
    this.refreshView();
  }

  private refreshView(): void {
    this.cdr.detectChanges();
    scheduleAppRefresh(this.appRef, this.ngZone);
  }

  private showResumeDialog(etapa: string, arquivo: string): void {
    this.setFirstLoading(false);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      disableClose: true,
      data: {
        header: 'Continuar de onde parou?',
        body: `Arquivo ${arquivo} - Etapa: ${etapa}`,
        confirm: 'Sim',
        icon: 'error',
        confirmAction: () => {
          if (etapa === 'Corrigir Linhas') {
            this.showStepError = true;
          } else {
            this.showStepFail = true;
          }
        }
      }
    });

    this.refreshView();

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result?.action === 'cancelled') {
          this.importServiceV3.cancelarUltimaImportacao().subscribe({
            next: () => {
              this.novaImportacao();
            },
            error: (err) => {
              this.novaImportacao();
              setTimeout(() => {
                const message = this.commonService.getErrorMessage(err);
                if (message !== '') {
                  this.showErrorMessage(this.dialog, message);
                }
              }, 100);
            }
          });
        } else {
          this.pollImportStatus();
          this.refreshView();
        }
      },
      error: () => {
        this.novaImportacao();
      }
    });
  }

  public changeStep(step: StepsImport): void {
    if (this.currentStep === step) {
      this.refreshView();
      return;
    }
    this.currentStep = step;

    if (step === StepsImport.stepProcessing) {
      this.homeComponent.setNewVariables('Importação de Arquivo CSV Personalizado', '', undefined);
      this.checkedStepUpload = true;
    } else if (step === StepsImport.stepResult) {
      this.homeComponent.setNewVariables('Importação de Arquivo CSV Personalizado', '', undefined);
      this.checkedStepUpload = true;
      this.checkedStepProcessing = true;
    }

    this.refreshView();
  }

  public novaImportacao = () => {
    this.changeStep(StepsImport.stepUpload);
    this.checkedStepUpload = false;
    this.checkedStepProcessing = false;
    this.showProcessing = false;
    this.showStepAlert = false;
    this.showStepError = false;
    this.showStepFail = false;
    this.showStepCounters = false;
    this.errorsToShow = [];
    this.detalhamento = null;
    this.alertTitle = '';
    this.alertMessage = '';
    this.alertError = '';
    this.homeComponent.setNewVariables('Importação de Arquivo CSV Personalizado', '', 'importacao/importar-arquivo');
    this.filesDataForm.reset();
    this.setFirstLoading(false);
  };

  public continueFromError = () => {
    if (!this.idImportacao) return;
    this.checked = true;
    this.isChecking = false;
    this.showStepError = false;
    this.showStepFail = false;
    this.showProcessing = true;
    const subscription = this.importServiceV3
      .corrigirLinhas(this.idImportacao.toString(), this.editedLines, ImportServiceV3LoadingKeys.Default)
      .subscribe({
        next: () => {
          setTimeout(() => {
            if (this.enableLoop) {
              this.pollImportStatus();
            }
          }, 20000);
        },
        error: (e) => {
          this.showStepError = false;
          this.showStepAlert = true;
          this.showProcessing = false;

          this.alertTitle = 'Erro ao corrigir linhas';
          this.alertMessage = `Tente novamente ou contate a`;
          this.alertError = e.error?.mensagem || e.message;
        }
      });

    this.subscriptions.push(subscription);
  };

  public continueFromFail = () => {
    if (!this.idImportacao || !this.columnMappings) return;
    this.checked = true;
    this.isChecking = false;
    this.showProcessing = true;
    this.showStepFail = false;
    this.showStepError = false;
    const subscription = this.importServiceV3
      .corrigirCabecalho(this.idImportacao.toString(), this.columnMappings, ImportServiceV3LoadingKeys.Default)
      .subscribe({
        next: () => {
          setTimeout(() => {
            if (this.enableLoop) {
              this.pollImportStatus();
            }
          }, 20000);
        },
        error: (e) => {
          this.showStepFail = false;
          this.showStepAlert = true;
          this.showProcessing = false;

          this.alertTitle = 'Erro ao corrigir cabeçalho';
          this.alertMessage = `Tente novamente ou contate a`;
          this.alertError = e.error?.mensagem || e.message;
        }
      });

    this.subscriptions.push(subscription);
  };
}
